var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnableclone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.518,
    height: 19.126,
    viewBox: "0 0 16.518 19.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-content-copy",
    "data-name": "Icon material-content-copy",
    d: "M15.171,1.5H4.739A1.744,1.744,0,0,0,3,3.239V15.41H4.739V3.239H15.171Zm2.608,3.477H8.216A1.744,1.744,0,0,0,6.477,6.716V18.887a1.744,1.744,0,0,0,1.739,1.739h9.563a1.744,1.744,0,0,0,1.739-1.739V6.716A1.744,1.744,0,0,0,17.779,4.977Zm0,13.91H8.216V6.716h9.563Z",
    transform: "translate(-3 -1.5)",
    fill: "#7b7b7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableclone);
export default __webpack_public_path__ + "static/media/enableclone.b7ee28713df524b9d93097a7c7ec1315.svg";
export { ForwardRef as ReactComponent };